export default __webpack_public_path__ + "static/media/emptycirclePlus.3e3d2eeb.svg";